<template>
  <v-container>
    <v-col cols="12" sm="6" v-if="!isHideSites">
      <v-autocomplete
        label="Сайт"
        v-model="site"
        :items="sitesSelectData"
        filled
        clearable
        :disabled="loading"
        :loading="loading"
      ></v-autocomplete>
    </v-col>

    <v-data-table
      class="elevation-1"
      :headers="tableHeaders"
      :items="items"
      :search="search"
      :loading="loading"
      :key="site"
    >
      <template v-slot:top>
        <v-row class="ma-0 pa-0 ml-2 mr-2">
          <v-col cols="10" sm="8">
            <v-text-field
              placeholder="Введите данные для поиска"
              v-model="search"
            ></v-text-field>
          </v-col>
          <v-col cols="2" sm="4" class="d-flex pt-5">
            <v-spacer></v-spacer>
            <component :is="cardComponent"></component>
          </v-col>
        </v-row>
      </template>

      <template v-slot:[`item.site`]="{ item }">
        <template v-if="Boolean(item.site)">
          {{ sitesSelectData.find(x => x.value == item.site).text }}
        </template>
        <template v-else>-</template>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <component :is="cardComponent" :id="item._id" :key="item._id"></component>

        <delete-button
          :id="item._id"
          :deleteFunc="deleteEntity"
          objName="сущность"
        >
          Тип сущности: {{ tag }}
        </delete-button>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'base-entities-list',

  props: {
    tag: String,
    cardComponent: Object,
    innerTableHeaders: Array,
    enrichFunc: Function,
    isHideSites: Boolean
  },

  data() {
    return {
      site: null,
      search: '',
      tableHeaders: [
        {
          text: '№',
          value: 'index'
        },
        {
          text: 'Сайт',
          value: 'site'
        },
        ...this.innerTableHeaders,
        {
          text: 'Действия',
          value: 'actions'
        }
      ]
    }
  },

  created() {
    this.$store.dispatch('sites/loadEntitiesList', { tag: this.tag, site: null });
  },

  methods: {
    async deleteEntity(id) {
      return this.$store.dispatch('sites/deleteEntity', { tag: this.tag, id });
    }
  },

  watch: {
    site(newVal) {
     this.$store.dispatch('sites/loadEntitiesList', { tag: this.tag, site: newVal });
    }
  },

  computed: {
    sitesSelectData() {
      return this.$store.getters['sites/sitesSelectData'];
    },
    items() {
      let items = this.$store.state.sites.entities[this.tag].map((x, index) => ({ ...x, index }));
      if (this.enrichFunc) {
        items.forEach(elem => this.enrichFunc(elem));
      }
      return items;
    },
    loading() {
      return this.$store.getters['sites/loadingEntity'](this.tag, 'list');
    },

  }
}
</script>